module.exports = __webpack_public_path__ + "static/media/tk.595812eb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tk.svg
// module id = 956
// module chunks = 0